export function joinCapitalCase(value: string | string[]): string {
  if (typeof value === 'string') {
    value = value.split(/[\-_\.\s]+/).filter(v => v);
  }
  return value.map(v => v[0].toUpperCase() + v.substr(1)).join('');
}

export function isObject(item: any) {
  return item && typeof item === 'object' && !Array.isArray(item);
}

export function mergeDeep(target: any, source: any) {
  const output = Object.assign({}, target);
  if (!isObject(target) || !isObject(source)) {
    return output;
  }
  Object.keys(source).forEach(key => {
    if (!isObject(source[key]) || !(key in target)) {
      output[key] = source[key];
      return;
    }
    output[key] = mergeDeep(target[key], source[key]);
  });
  return output;
}

export function getInnermostChild(obj: any, prop: string): any {
  let result = obj;
  while (result[prop]) {
    result = result[prop];
  }
  return result;
}
